app.controller('ProductController', ['$scope','Config','$timeout','cart','toaster','product','helper', function($scope,Config,$timeout,cart,toaster,product,helper){

	$scope.product = null;
	$scope.base_url = Config.base_url;
	$scope.productService = product;
	$scope.cartService = cart;
	$scope.qty=1;

	$scope.init = function(){
		$scope.getProduct();
	}

	$scope.getProduct = function(){
		width = 520;
		height = 520;

		$scope.productService.getProduct(width,height).then(function(response) {
		   	$scope.product = response.data;
		   	$timeout(function () {
		   		helper.hideLoader();
			}, 100);
		  }, function(response) {
		    console.log(response);
		  });
	}

	$scope.incQty = function(){
		$scope.qty++;
	}

	$scope.decQty = function(){
		if($scope.qty>=1){
			$scope.qty--;
		}
	}

	$scope.cartAdd = function(qty){
		//get product from the group
		cart.add($scope.product,qty);
		$scope.qty = 1;
		$('#quoteModal').modal('show');
	}

	$scope.lowestPrice = function(product,discount){
		//check if there is price breaks
		if(product.price_breaks.length>0){
			//if yes then get the lowest one
			return (Object.values(product.price_breaks).reverse())[0].price;
		}else{
			//if no then return the normal price
			if(discount){
				return product.discounted_price;
			}else{
				return product.price;
			}
		}
	}

}]);



